// extracted by mini-css-extract-plugin
export default {"cards":"App_cards__iOJup","container":"App_container__Rt8T2","card-selected":"App_card-selected__BueUm","in-game":"App_in-game__q7tzZ"};